import React    from 'react';
import {render} from 'react-dom';

import axios from 'axios';

class Bid extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      bid: this.props.bid,
      bid_amount: this.props.bid.amount
    }
  }

  render() {
    return(
      <div className="price-input-area">
        <div className="row">
          <div className="col-sm-4 col-xs-3">
            <h4>{I18n.t('components.bid.enter_price')}</h4>
          </div>
          <div className="col-sm-8 col-xs-9">
            <input className="form-control" type="number" value={this.state.bid_amount} onChange={this.handleChange} min={this.state.bid.amount} disabled={this.submissionDisabled()}/>
            <button className="btn btn-blue" onClick={this.handleSubmit} disabled={this.submissionDisabled()}>
              <strong>{this.bidButtonText()}</strong>
            </button>
          </div>
        </div>
        <br/>
        {this.state.bid.id != null &&
          <div>
            <div className="row">
              <div className="col-sm-4 col-xs-3">
                <h4>{this.bidText()}</h4>
              </div>
              <div className="col-sm-8 col-xs-9">
                <p>{this.state.bid.amount_formatted}</p>
              </div>
            </div>
            <br/>
          </div>
        }
        {this.informationText().length > 0 &&
          <p className="grey">
            <i aria-hidden="true" className="fa fa-info-circle"></i>
            {this.informationText()}
          </p>
        }
      </div>
    )
  }

  bidText = () => {
    if (this.submissionDisabled()) {
      return I18n.t('components.bid.final_bid')
    } else {
      return I18n.t('components.bid.current_bid')
    }
  }

  bidButtonText = () => {
    if (this.state.bid.id != null) {
      return I18n.t('components.bid.update_bid')
    } else {
      return I18n.t('components.bid.place_bid')
    }
  }

  informationText = () => {
    let strings = []
    if (!this.state.bid.active_sale) {
      strings.push(I18n.t('components.bid.closed_tender'))
    }

    if (this.state.bid.id != null) {
      strings.push(I18n.t('components.bid.bid_once'))
    }

    return strings.join(" ")
  }

  handleChange = (e) => {
    this.setState({
      bid_amount: e.target.value
    })
  }

  submissionDisabled = () => {
    let {active_sale, allowed_to_update} = this.state.bid;
    return !(active_sale && allowed_to_update)
  }

  handleSubmit = () => {
    swal({
      title: I18n.t('components.bid.swal.default.title'),
      text: I18n.t('components.bid.swal.default.text'),
      type: 'question',
      showCancelButton: true,
    }).then(() => {
      axios({
        method:'post',
        url:`/marketplace/${this.props.marketplace_id}/bids.json`,
        data: {
          amount: this.state.bid_amount
        },
        responseType:'json'
      })
      .then((response) => {
        this.setState({
          bid: response.data.bid
        })
        swal({
          type: 'success',
          title: I18n.t('components.bid.swal.success.title'),
        }).catch(swal.noop)
      })
      .catch((error) => {
        if (error.response.data.bid != null) {
          this.setState({
            bid: error.response.data.bid
          });
        }
        swal({
          type: 'error',
          title: I18n.t('components.bid.swal.fail.title'),
          text: error.response.data.message
        }).catch(swal.noop)
      });
    }).catch(swal.noop)

  }
}

export default Bid;


